import { sum } from 'lib/array/arrayUtils'
import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getCheckoutLoyaltyBurningPointItems from './getCheckoutLoyaltyBurningPointItems'

export const getCheckoutLoyaltyBurnTotalInPoints = createSelector(
  (state: App.State) => getCheckoutLoyaltyBurningPointItems(state),
  (
    burningPointItems,
  ): number => {
    return sum(
      burningPointItems,
      (item) => item.pointsPaid,
    )
  },
)

export const getCheckoutLoyaltyBurnTotalInCurrency = createSelector(
  (state: App.State) => getCheckoutLoyaltyBurningPointItems(state),
  (
    burningPointItems,
  ): number => {
    return floatify(sum(
      burningPointItems,
      (item) => item.pointsPaidInCurrency,
    ))
  },
)
